module.exports = __webpack_public_path__ + "static/media/find_us_on_fb.bec02c32.png";